<!-- 对公打款 页面 -->
<template>
  <div class="mian_wrap">
    <div :class="classNames + '_search_outer'">
      <div class="title-box">
        <div class="left">
          对公打款基础信息
        </div>
        <div class="right blue-pointer" @click="goHistory">
          对公打款申请记录<i class="el-icon-arrow-right"></i>
        </div>
      </div>
      <div :class="classNames + '_search'">
        <div :class="classNames + '_search_con'">
          <div :class="classNames + '_search_con_item'">
            <span :class="classNames + '_search_con_item_title'">请选择订单成交时间</span>
            <el-date-picker
              v-model="searchObj.date"
              type="month"
              value-format="yyyy-MM"
              placeholder="请选择月份">
            </el-date-picker>
          </div>
        </div>
  
        <div :class="classNames + '_search_con'">
          <div :class="[classNames + '_search_con_item', classNames + '_class_select']">
            <span :class="classNames + '_search_con_item_title'">请选择渠道</span>
            <el-select :clearable="true" style="width: 200px;" v-model="searchObj.come_froms" :multiple="true" collapse-tags placeholder="请选择渠道(支持多选)">
              <el-option v-for="(item) in channelList" :label="item.label" :value="item.value" :key="item.value" style="max-width:280px;"></el-option>
            </el-select>
          </div>
        </div>
        <div :class="classNames + '_search_con'">
          <div :class="[classNames + '_search_con_item', classNames + '_oprtation']">
            <el-button type="primary" @click="searchRes">查询</el-button>
          </div>
        </div>
      </div>
    </div>

    <!-- 订单/课程table -->
    <div :class="classNames + '_con'">
      <div class="title-box">
        <el-radio-group style="margin-top: 20px;" v-model="tableActiveTab" @input="tableTabChange">
          <el-radio-button v-for="(item,index) in tableTabList" :key="index" :label="item.value">{{ item.label }}</el-radio-button>
        </el-radio-group>
        <div class="right blue-pointer" @click="exportBtnFn(1)">
          导出明细
        </div>
      </div>
      
      <div :class="classNames + '_con_table'">
        <el-table :data="tableData.list" :header-cell-style="{ background: '#F5F7FA', color: '#454D53' }" >
          <div slot="empty">
            <img :src="require(`@/assets/image/${noDataName}.png`)" style="width: 100%; padding: 115px 0" />
          </div>
          <el-table-column
            :label="item.label"
            :prop="item.prop"
            :width="item.width"
            v-for="(item, index) in tableHeaderList"
            :type="item.prop"
            :key="index"
          >
            <template slot-scope="scope">
              <div>
                {{ scope.row[item.prop] ? scope.row[item.prop] : "--" }}
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <Pagination
        @change="changePage"
        :total="tableData.total"
        ref="pagination"
        v-model="searchObj.page"
        v-if=tableData.total > 0"
      ></Pagination>
    </div>

    <!-- 汇总table -->
    <div :class="classNames + '_con'">
      <div class="title-box summary-box">
        <div class="left" style="display: flex;">
          汇总
          <div class="left-sub">
            <span>结算总单数: {{ sumData.total_settle }}</span>
            <span>总收益: {{ sumData.total_income }}</span>
          </div>
        </div>
        <div class="right blue-pointer"  @click="exportBtnFn(2)">
          导出明细
        </div>
      </div>
      <div :class="classNames + '_con_table'">
        <el-table :data="sumData.my_list" :header-cell-style="{ background: '#F5F7FA', color: '#454D53' }" >
          <div slot="empty">
            <img :src="require(`@/assets/image/${noDataName}.png`)" style="width: 100%; padding: 20px 0 0" />
          </div>
          <el-table-column
            :label="item.label"
            :prop="item.prop"
            :width="item.width"
            v-for="(item, index) in sumTableHeaderList"
            :type="item.prop"
            :key="index"
          >
            <template slot="header" slot-scope="scope">
              <div v-if="item.tip" style="cursor: pointer;">
                <el-tooltip placement="top">
                  <div slot="content" v-html="item.tip"></div>
                  <div>{{ item.label }}<i class="el-icon-question question-icon"></i></div>
                </el-tooltip>
              </div>
              <div v-else>
                {{ item.label }}
              </div>
            </template>
            <template slot-scope="scope">
              <div v-if="item.prop == 'dy_merchant_income'">
                {{ scope.row[item.prop] }}
                <i v-if="scope.row[item.prop]!='0.00'" @click="seeDyAccountProfit" class="el-icon-question blue-pointer" style="color: red;"></i>
              </div>
              <div v-else>
                <!-- {{ scope.row[item.prop] ? scope.row[item.prop] : "--" }} -->
                {{ scope.row[item.prop] }}
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="create-btn-box">
      <el-button type="primary" @click="createBill">生成打款账单</el-button>
    </div>
    <dyAccountProfit v-model="showDyAccountProfitPop" :tableList="sumData.my_dyList"></dyAccountProfit>
  </div>
</template>

<script>
import { toPublicPayment_orderHeaderList, toPublicPayment_classHeaderList, toPublicPayment_summaryHeaderList } from './data.js'
import { exportAboutMixin } from '@/components/mixin/mixin.js'
import { frontEndExportMixin } from '@/components/mixin/frontEndExportMixin.js'
import dyAccountProfit from './components/dyAccountProfit.vue'
import { mapActions } from 'vuex'

export default {
  name: 'toPublicPayment',
  mixins: [ exportAboutMixin, frontEndExportMixin ],
  components: {
    dyAccountProfit
  },
  data() {
    return {
      classNames: "toPublicPayment",
      noDataName: "empty",
      searchObj: {
        page: 1,
        page_size: 10,
        date: '', // 订单成交时间
        come_froms: [],// 渠道
      },
      channelList: [
        { label: '抖音小程序', value: 1, path: '/' },
        { label: '快手小程序', value: 2, path: '/ks/' },
        { label: '微信小程序', value: 3, path: '/wx/' },
      ],//渠道列表
      tableHeaderList: toPublicPayment_orderHeaderList, // 订单/课程table表头
      tableData: {
        list: [],
        total: 0,
        my_searchObj: {}
      }, // 订单/课程table数据
      tableActiveTab: 1, // 订单/课程table 当前激活tab
      tableTabList: [{label: '订单明细',value: 1}, {label: '课程明细',value: 2}],  // 订单/课程table tab
      sumTableHeaderList: toPublicPayment_summaryHeaderList, // 汇总table表头
      sumData: { // 汇总数据
        total_settle: '--',
        total_income: '--',
        my_list: [],
        my_dyList: [],
        my_date: '',
        my_come_from: []
      },
      showDyAccountProfitPop: false, // 展示抖音商户收益弹窗
    }
  },
  methods: {
    ...mapActions('toPublicPayment',['getSummaryAPI','getOrderListDetailAPI','getClassListDetailAPI']),
    // 查看抖音商户收益
    seeDyAccountProfit(){
      this.showDyAccountProfitPop = true
    },
    // 点击 ‘对公打款申请记录’
    goHistory(){
      this.$router.push({
        path: this.staticPath + "applyPaymentHistory"
      })
    },
    // 点击 '生成打款账单'
    createBill(){
      let { my_date, my_come_from, my_list } = this.sumData
      if(!my_date || !my_come_from.length){
        this.$message({
          type: "error",
          message: "请先选择成交时间和渠道并点击查询按钮",
          duration: 3000,
        })
        return
      }
      for(let i = 0; i<my_list.length; i++){
        let item = my_list[i]
        if(item.pay_count != item.settle_count){
          this.$message({
            type: "error",
            message: `${item.come_from_desc}渠道，成交单数与结算单数不一致，不允许生成账单，请联系客服处理`,
            duration: 3000,
          })
          return
        }
      }
      this.$router.push({
        path:  `${this.staticPath}paymentBill` ,
        query: {
          date:  encodeURIComponent(window.btoa(JSON.stringify(my_date))),
          come_froms:  encodeURIComponent(window.btoa(JSON.stringify(my_come_from))) ,
        }, 
      })
    },
    // 点击 导出
    exportBtnFn(type){ // type: 1=订单/课程table 2=汇总table 
      if(type==1){ // 异步导出走后端
        let { my_searchObj } = this.tableData
        if(!my_searchObj.date || !my_searchObj.come_froms?.length){
          this.$message({
            type: "error",
            message: "请先选择成交时间和渠道并点击查询按钮",
            duration: 3000,
          })
          return
        }
        if(this.tableActiveTab==1){ // 导出订单明细
          this.exportExcel(9, this.tableData.my_searchObj) 
        }
        if(this.tableActiveTab==2){ // 导出课程明细
          this.exportExcel(6, this.tableData.my_searchObj) 
        }
      }
      if(type==2){
        let newList = []
        let { my_dyList } = this.sumData
        let list = JSON.parse(JSON.stringify(toPublicPayment_summaryHeaderList)) 
        list.splice(list.findIndex(item=>item.prop=='dy_merchant_income'),1)
        let dyAccountList = my_dyList.map(item => {
          return {
            prop: 'my_dy_account',
            label: `抖音商户(${item.account})`,
            value: item.income
          }
        })
        list.splice(5, 0, ...dyAccountList) // 在下标5插入具体的抖音商户
        list.push({
          prop: 'pay_time_range',
          label: '成交时间',
        })
        this.sumData.my_list.forEach(item=>{
          let newItem = {}
          list.forEach(item2=>{
            if(item.come_from==1 && item2.prop=='my_dy_account'){
              newItem[item2.label] = item2.value
            }else{
              newItem[item2.label] = item[item2.prop] || ''
            }
          })
          newList.push(newItem)
        })
        this.mixin_exportToCsv(newList, `${this.sumData.my_date}汇总.csv`)
      }
    },
    // 点击查询按钮
    searchRes(){
      this.getTableData(true)
    },
    // 改变页数
    changePage(pageNum){
      this.searchObj.page = pageNum;
      this.getTableData();
    },
    // 订单/课程table tab切换
    tableTabChange(e){
      switch(e){
        case 1:
          this.tableHeaderList = toPublicPayment_orderHeaderList
          break;
        case 2: 
          this.tableHeaderList = toPublicPayment_classHeaderList
          break;
        default: 
          console.error("无此tab-tableTabChange-e:", e)
          break;
      }
      this.searchRes()
    },
    // 获取表格数据
    async getTableData(flag){
      if (flag) {
        this.searchObj.page = 1;
      }
      let res = {}
      if(this.tableActiveTab==1){
        res = await this.getOrderListDetailAPI(this.searchObj)
      }
      if(this.tableActiveTab==2){
        res = await this.getClassListDetailAPI(this.searchObj)
      }
      // console.log('getTableData-res:',res)
      this.tableData.my_searchObj = this.searchObj
      this.tableData.list = res.data || []
      this.tableData.total = res.total || 0
      if(flag){
        this.getSummary()
      }
    },
    // 获取汇总数据
    async getSummary(){
      let res = await this.getSummaryAPI(this.searchObj)
      // console.log('getSummary-res:',res)
      let my_list = []
      let my_dyList = []
      let my_date = this.searchObj.date
      let my_come_from = this.searchObj.come_froms
      for(let k in res.data){
        my_list.push(res.data[k])
      }
      for(let k in res.dy_merchant_income){
        my_dyList.push({
          account: k,
          income: res.dy_merchant_income[k]
        })
      }
      this.sumData = {...res, my_list, my_dyList, my_date, my_come_from}
    }
  }
}
</script>

<style lang="less" scoped>
@classNames: toPublicPayment;
.mian_wrap {
  background-color: #fff;
  border-radius: 5px;
  box-sizing: border-box;
  position: relative;
  min-height: 550px;
  .@{classNames}_search_outer{
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    padding: 18px 10px;
    .title-box{
      display: flex;
      justify-content: space-between;
      align-items: center;
      .left{
        font-size: 18px;
        font-weight: 600;
      }
    }
    .@{classNames}_search {
      margin-top: 20px;
      display: flex;
      flex-shrink: 0;
      padding-bottom: 20px;
      box-sizing: border-box;
      flex-wrap: wrap;
      align-content: center;
      .@{classNames}_search_con {
        display: flex;
        margin-right: 20px;
  
        .@{classNames}_search_con_item {
          display: flex;
          align-items: center;
          margin-right: 16px;
  
          .@{classNames}_search_con_item_title {
            white-space: nowrap;
            font-size: 14px;
            color: #606266;
            margin-right: 12px;
          }
        }
      }
    }
  }

  .@{classNames}_oprtation {
    flex: 1 0 auto;
    display: flex;
    justify-content: flex-start;
    position: relative;

    .el-button--primary {
      margin: 0 6px;
    }

    .total_sums {
      position: absolute;
      top: 50%;
      transform: translateX(-50%);
      right: 0;
      font-weight: normal;
      color: #606266;
    }
  }

  .@{classNames}_con {
    flex: 1;
    display: flex;
    flex-direction: column;
    margin-top: 20px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    padding: 0px 14px 18px;
    .title-box{
      display: flex;
      justify-content: space-between;
      align-items: center;
      .left{
        font-size: 18px;
        font-weight: 600;
      }
      &.summary-box{
        padding-top: 20px;
        .left{
          .left-sub{
            font-size: 14px;
            font-weight: 400;    
            >span{
              margin-left: 20px;
              vertical-align: sub;
            }
          }
        }
      }
    }
    .@{classNames}_con_table{
      margin-top: 12px;
    }
    .@{classNames}_nickname {
      display: flex;
      align-items: center;
      img {
        width: 80px;
        height: 60px;
        margin-right: 10px;
        object-fit: cover;
      }
    }
  }
}
.create-btn-box{
  display: flex;
  justify-content: center;
  margin: 20px 0 50px;
}
.blue-pointer{
  cursor: pointer;
  color: #1989fa;
  font-size: 14px;
}

</style>